import { Stack } from '@mui/material';
import { useFragment } from '../../../hooks/useFragment';
import { DownloadFragmentVideoAudioMp3Btn } from './DownloadFragmentVideoAudioMp3Btn';
import { ForceDownloadMediaBtn } from './ForceDownloadMediaBtn';

export function DownloadBtns() {
  const { fragment } = useFragment();
  const audioUrl = fragment.assets.audio?.url;
  const videoUrl = fragment.assets.video?.url;
  const isVideo = fragment.mediaType === 'VIDEO';

  return (
    <Stack direction="row" spacing={2}>
      {isVideo && videoUrl ? <ForceDownloadMediaBtn mediaUrl={videoUrl} mediaType="VIDEO" /> : null}
      {audioUrl ? (
        <ForceDownloadMediaBtn mediaUrl={audioUrl} mediaType="AUDIO" showExtension={isVideo} />
      ) : null}
      {isVideo && <DownloadFragmentVideoAudioMp3Btn audioMp3Url={fragment.assets.audioAlt?.url} />}
    </Stack>
  );
}
